import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-errorv1',
  templateUrl: './errorv1.component.html',
  styleUrls: ['./errorv1.component.scss']
})
export class Errorv1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
